import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F05DF9FC-A193-444F-8B6E-24862443BA63
 * name view-dashboard-variant-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-dashboard-variant-outline.svg
 * tags
 * - View 
 */
export const ViewDashboardVariantOutlineIcon = createSvgIcon(<><path d="M2 5V19H22V5H2M20 12H16V7H20V12M14 10H10V7H14V10M10 12H14V17H10V12M4 7H8V17H4V7M16 17V14H20V17H16Z" /></>, 'ViewDashboardVariantOutlineIcon');
export default ViewDashboardVariantOutlineIcon